// TODO: document. Copied over from @caresend-webapp-vuejs/src/functions/methods.ts
const removeSpaces = (str) => str.replace(/\s/g, '');

export { removeSpaces };
